import { createSharedComposable } from '@vueuse/core';

import { useGetEntities } from '@abaninja/util-store';

import { getAccounts } from '../accounts';

export const useAccountsStore = createSharedComposable(() => useGetEntities(getAccounts));
